import request from '@/utils/request'

// 查询列表
export function apiScpPlanParametersList (query) {
  return request({
    url: '/scp/scpPlanParameters/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiScpPlanParametersNewExport (data) {
  return request({
    url: '/scp/scpPlanParameters/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiScpPlanParametersUpdate (data) {
  return request({
    url: '/scp/scpPlanParameters',
    method: 'put',
    data: data
  })
}

// 新增
export function apiScpPlanParametersAdd (data) {
  return request({
    url: '/scp/scpPlanParameters',
    method: 'post',
    data: data
  })
}

// 删除
export function apiScpPlanParametersDelete (id) {
  return request({
    url: `/scp/scpPlanParameters/${id}`,
    method: 'delete'
  })
}

// 参数名称
export function apiScpPlanParametersParameterValueBox (query) {
  return request({
    url: '/scp/scpPlanParameters/parameterValueBox',
    method: 'get',
    params: query
  })
}
